import normalize from 'json-api-normalizer';
import User from './user.js';

export default class Message {
	static from (jsonapi) {
		let key = 'messages'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = Message.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return Message.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi, noRelationships=0) {
		const { id, attributes } = jsonapi;

		let relationships = {}
		if (normalizedJSONapi['users'] && normalizedJSONapi['users'][attributes['senderId']] && noRelationships == 0 ) {
			relationships["sender"] = User.make(normalizedJSONapi["users"][attributes.senderId], normalizedJSONapi);
		}

		if (jsonapi.relationships && jsonapi.relationships.to && noRelationships == 0) {
			relationships['to'] = {};
			jsonapi.relationships.to.data.forEach( function (rel) {
				if (normalizedJSONapi[rel.type] && normalizedJSONapi[rel.type][rel.id]) {
					relationships['to'][rel.id] = User.make(normalizedJSONapi[rel.type][rel.id], normalizedJSONapi);
				}
			});
		}

		if (jsonapi.relationships && jsonapi.relationships.bcc && noRelationships == 0) {
			relationships['bcc'] = {};
			jsonapi.relationships.bcc.data.forEach( function (rel) {
				if (normalizedJSONapi[rel.type] && normalizedJSONapi[rel.type][rel.id]) {
					relationships['bcc'][rel.id] = User.make(normalizedJSONapi[rel.type][rel.id], normalizedJSONapi);
				}
			});
		}

		return new Message( Object.assign({id: id}, attributes, relationships) );
	}

	constructor ({ id, body, folderId, folderName, readAt, senderId, sentAt, subject, sysmsg, urgent, to, bcc, sender, responseTo, deletedAt }) {
		this.id               = id ? id : -1
		this.bcc              = bcc ? bcc : []
		this.body             = body ? body : '';
		this.folder_id        = folderId ? folderId : -1;
		this.folder_name      = folderName ? folderName : '';
		this.read_at          = readAt ? readAt : null;
		this.sender_id        = senderId ? senderId : -1;
		this.sent_at          = sentAt ? sentAt : null;
		this.subject          = subject ? subject : '';
		this.sysmsg           = sysmsg ? sysmsg : false;
		this.to               = to ? to : []
		this.urgent           = urgent ? urgent : false;
		this.sender           = sender ? sender : new User({});

		this.response_to      = responseTo ? responseTo : {};
		this.deleted_at		  = deletedAt ? deletedAt : null;
	}

	toJSONapi () {
		let attributes = Object.assign({}, this);

		delete attributes.to;
		delete attributes.bcc;
		delete attributes.id;
		delete attributes.response_to;

		let messageRecipient = [];
		if (Array.isArray(this.to)) {
			this.to.forEach(function(val) {
			messageRecipient.push({id: val, type: 'message_recipients', attributes: {"recipient_id": val, bcc: false}});
			});
		} else if (typeof this.to == 'object') {
			for (var data in this.to) {
			messageRecipient.push({id: this.to[data].id.toString(), type: 'message_recipients', attributes: {"recipient_id": this.to[data].id.toString(), bcc: false}});
			}
		} else if (this.to) {
			messageRecipient.push({id: this.to, type: 'message_recipients', attributes: {"recipient_id": this.to, bcc: false}});
		}

		if (Array.isArray(this.bcc)) {
			this.bcc.forEach(function(val) {
			messageRecipient.push({id: val, type: 'message_recipients', attributes: {"recipient_id": val, bcc: true}});
			});
		} else if (typeof this.bcc == 'object') {
			for (var data in this.bcc) messageRecipient.push({id: this.bcc[data].id, type: 'message_recipients', attributes: {"recipient_id": this.bcc[data].id, bcc: true}});
		} else if (this.bcc) {
			messageRecipient.push({id: this.bcc, type: 'message_recipients', attributes: {"recipient_id": this.bcc, bcc: true}});
		}

		let value = {data: {type: "messages", id: this.id, attributes: attributes}, relationships: {"message_recipients": {data: messageRecipient}} };
		return value;
	}
}
